module.exports = __webpack_public_path__ + "static/media/laura-cat.32b85e30.jpg";